import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Brain, Flame, Zap, ChevronRight, Sparkles } from "lucide-react";

const bandColor = (s) => (s >= 90 ? "#22D3EE" : s >= 75 ? "#A3E635" : s >= 60 ? "#FACC15" : s >= 40 ? "#FB923C" : "#F87171");

export const BrainHubCard = () => {
  const navigate = useNavigate();
  const [st, setSt] = useState(null);
  useEffect(() => { api.get("/brain/status").then(({ data }) => setSt(data)).catch(() => {}); }, []);

  return (
    <div data-testid="brain-hub-card" className="bg-pb-surface border border-cyan-400/40 p-6 relative overflow-hidden flex flex-col shadow-[0_0_24px_rgba(34,211,238,0.12)]">
      <div className="text-[10px] uppercase tracking-[0.2em] text-cyan-300 mb-3 flex items-center gap-2">
        <Brain className="w-4 h-4 animate-pulse" /> PBPA Court Mentality Training Hub
      </div>
      <div className="flex items-end gap-3 mb-3">
        <div className="font-display font-black text-6xl leading-none" style={{ color: st?.iq == null ? "#52525B" : bandColor(st.iq) }}>
          {st?.iq == null ? "—" : Math.round(st.iq)}
        </div>
        <div className="pb-0.5">
          <div className="text-[9px] uppercase tracking-[0.2em] text-zinc-500">Brain IQ</div>
          <div className="font-black uppercase text-sm" style={{ color: st?.iq == null ? "#71717A" : bandColor(st.iq) }}>
            {st?.iq_band || "Unrated"}
          </div>
        </div>
        {st && (
          <div className="ml-auto text-right pb-0.5">
            <div className="flex items-center justify-end gap-3 text-xs">
              <span className="flex items-center gap-1 text-orange-400 font-bold"><Flame className="w-3.5 h-3.5" />{st.streak}d</span>
              <span className="flex items-center gap-1 text-amber-400 font-bold"><Zap className="w-3.5 h-3.5" />{st.xp}</span>
            </div>
            <div className="text-[9px] uppercase tracking-[0.15em] text-zinc-600 mt-0.5">{st.attempts} scenarios</div>
          </div>
        )}
      </div>
      <div className="space-y-2 mb-4 flex-1">
        {st ? Object.entries(st.facets).slice(0, 4).map(([k, v]) => (
          <div key={k} className="flex items-center gap-2">
            <div className="text-[9px] uppercase tracking-wider text-zinc-500 w-32 shrink-0">{k}</div>
            <div className="flex-1 h-1 bg-pb-elevated"><div className="h-full transition-all duration-700" style={{ width: `${v || 0}%`, background: v == null ? "transparent" : bandColor(v) }} /></div>
            <div className="text-[9px] font-bold w-6 text-right" style={{ color: v == null ? "#52525B" : bandColor(v) }}>{v == null ? "—" : Math.round(v)}</div>
          </div>
        )) : <p className="text-xs text-zinc-500">Read real court situations. Make the call. An AI tactician grades every decision across 10 dimensions.</p>}
      </div>
      {st?.daily_challenge && !st.daily_challenge.completed && (
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.15em] text-amber-400 mb-3">
          <Sparkles className="w-3.5 h-3.5" /> Today's Challenge: {st.daily_challenge.category} · 2× XP
        </div>
      )}
      <button data-testid="enter-brain-hub-btn" onClick={() => navigate("/brain")}
        className="w-full flex items-center justify-center gap-2 bg-cyan-400 text-black px-4 py-3 text-[11px] font-black uppercase tracking-[0.2em] hover:bg-cyan-300 transition-colors active:scale-[.98]">
        {st?.quota && !st.quota.unlimited && st.quota.remaining <= 0 ? "View My Brain" : st?.attempts ? "Continue Training" : "Test Your Pickleball IQ"} <ChevronRight className="w-4 h-4" />
      </button>
    </div>
  );
};
